var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToDo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_447_4576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 30.0001L33.48 45.3701C33.932 46.0031 34.523 46.5238 35.2077 46.8924C35.8923 47.2611 36.6527 47.4677 37.4297 47.4967C38.2067 47.5257 38.98 47.3761 39.6903 47.0594C40.4007 46.7427 41.0287 46.2674 41.5267 45.6701L77.5 2.49683",
    stroke: "#E59E6D",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5 35V67.5C72.5 70.152 71.4463 72.6957 69.571 74.571C67.6957 76.4463 65.152 77.5 62.5 77.5H12.5C9.84783 77.5 7.3043 76.4463 5.42893 74.571C3.55357 72.6957 2.5 70.152 2.5 67.5V17.5C2.5 14.8478 3.55357 12.3043 5.42893 10.4289C7.3043 8.55357 9.84783 7.5 12.5 7.5H55",
    stroke: "#E59E6D",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_447_4576"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToDo);
export default __webpack_public_path__ + "static/media/toDo.2e3db7129c8806e1f4fead0983336306.svg";
export { ForwardRef as ReactComponent };